var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-header-top-bar",style:({ backgroundColor: _vm.background })},[_c('CmsBlocks',{attrs:{"identifiers":_vm.identifier,"is-cms-content":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }